var React = require('react');

function PennsylvaniaInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M140.224 37.2048L136.039 47.7885L137.747 56.1066L142.88 62.3479L145.156 66.3126L143.639 70.2895L138.316 76.1533L131.676 78.4188L127.246 79.4061L124.077 80.1179L120.282 84.1271L120.271 84.1382H0V10.6169L1.37376 10.2727L5.16743 7.71839C5.16743 7.71839 8.68235 6.67446 8.97221 6.48566C9.25096 6.29687 9.63077 3.93138 9.63077 3.93138L13.6254 2.52097L18.2787 0.155478C18.2787 0.155478 18.3798 0.0999503 18.5574 0V8.09597H131.006L135.281 13.9597L137.936 19.2471C137.936 19.2471 139.074 22.4666 139.654 22.8442C140.224 23.2229 142.69 26.4324 142.69 26.4324L147.5 29.1977L147.242 29.4531L143.827 33.0513L140.224 37.2048Z","fill":"currentColor"}));
}

PennsylvaniaInline.defaultProps = {"width":"148","height":"85","viewBox":"0 0 148 85","fill":"none"};

module.exports = PennsylvaniaInline;

PennsylvaniaInline.default = PennsylvaniaInline;
